(function () {
    'use strict';

    angular
        .module(app.modules.scoring.name)
        .service('wagerReportService', wagerReportService);

    var
        rJsonTime = /^PT(?:([0-2]?\d)H)?(?:([0-5]?\d)M)?(?:([0-5]?\d)(?:\.(\d{1,3})\d*)?S)?$/

    wagerReportService.$inject = ['$http'
       , app.modules.common.constants.appsettings
    ];
    function wagerReportService($http, ggSettings) {
        this.getReport = getReport;

        function getReport(outingId, roundId) {


           var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.wagerReport;
           apipath = apipath.replace("(id)", "(" + outingId + ")");
           apipath = apipath.replace("(roundId)", "(" + roundId + ")");

          
           return $http.get(apipath, { transformResponse: transformResponse });
            // Note: if "C:\Work\GRP\GRP.Web\lib\golfnet\json-date.js" is included in project, then this is not needed.  I would probably break existing 
            // stuff if i did unfortunately.
            function transformResponse(data) {
                return JSON.parse(data, function reviver(key, value) {
                    if (key == 'time') {
                        var match = rJsonTime.exec(value);
                        if (match) {
                            var now = new Date();
                            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), match[1] || 0, match[2] || 0, match[3] || 0, match[4] || 0);
                        }
                        return null;
                    }
                    return value;
                });
            }
        }
    }

})();